export default __webpack_public_path__ + "static/media/blueArrow.1cf25150.svg";